import ReactDOM from 'react-dom';
import { initializeI18n } from '../localization/i18n';
import PaymentReturn from '../components/cart/PaymentReturn';

// Expose render function globally
window.renderPaymentReturn = (elementId, props) => {
    const element = document.getElementById(elementId);
    if (element) {

        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<PaymentReturn props={props} />, element);
            })
            .catch(error => {
                
            });

    } else {

    }
};